<template>
  <div class="grid grid-rows-[auto_1fr] h-full relative">
    <ThreadsNav :show-center="false" show-back>
      <template #right>
        <div class="flex gap-2 items-center">
          <button
            class="btn btn-primary btn-sm"
            @click="clickMode"
            v-if="canEdit"
          >
            {{
              $t("collection.mode." + (viewMode === "view" ? "edit" : "view"))
            }}
          </button>
          <Share
            v-if="collection.id"
            :share-id="collection.id!"
            share-type="collection"
          />
        </div>
      </template>
    </ThreadsNav>
    <div v-if="!collection.id" class="flex justify-center pt-24">
      <div class="loading loading-ring w-[50px]"></div>
    </div>
    <div
      v-else
      ref="scrollableEl"
      class="flex flex-col gap-4 overflow-auto"
      @scroll="saveScrollState"
    >
      <div class="relative flex flex-col min-h-[206px] overflow-hidden">
        <div class="flex justify-center items-center gap-4 relative z-10">
          <div class="relative flex h-[206px] w-[206px]">
            <BaseImg
              :key="collection.coverMediaId || 0"
              :media="collection.coverMedia"
              class="bg-primary"
              fit="cover"
              ratio="1:1"
            />
          </div>
          <div
            v-if="viewMode === 'edit'"
            class="absolute right-1 bottom-1.5 p-1 rounded flex gap-1"
          >
            <button
              class="btn btn-xs rounded flex items-center h-9"
              @click="
                router.push({
                  name: 'collectionEdit',
                  query: { uuid: route.params.uuid },
                })
              "
            >
              <i class="iconify mingcute--edit-3-line mt-[-5px]" />
            </button>
            <button
              class="btn btn-xs rounded flex items-center h-9"
              @click="clickDelete(collection.uuid!, collection.title!)"
            >
              <i class="iconfont icon-delete" />
            </button>
          </div>
        </div>
        <div
          :style="bannerStyle"
          class="absolute top-0 bottom-0 left-0 right-0 z-0"
        />
      </div>
      <div class="flex flex-col gap-1 px-2.5">
        <h3 class="text-2xl font-medium">{{ collection.title }}</h3>
        <div class="flex items-center flex-wrap">
          <span>{{ $t("collection.author") }}：</span>
          <template
            v-for="(item, idx) in collection.participantzz"
            :key="item.uuid"
          >
            <span
              class="text-primary cursor-pointer"
              @click="clickMate(item.uuid)"
            >
              {{ item.name }}
              <span v-if="idx !== collection.participantzz!.length - 1">
                ，
              </span>
            </span>
          </template>
        </div>

        <p class="whitespace-pre-line">
          {{ collection.description }}
        </p>

        <div
          v-if="viewMode === 'edit'"
          class="flex items-center justify-between cursor-pointer py-1"
          @click="showAddModal = true"
        >
          <div class="flex items-center gap-2 text-primary">
            <i class="iconfont icon-collection-plus"></i>
            <p>{{ t(`collection.addContent`) }}</p>
          </div>
          <i class="iconfont icon-i-right"></i>
        </div>
        <!-- <RankStatusOfEntity
          :item="collection"
          :type="CoinBalanceRecordEntityType.Collection"
        /> -->
      </div>

      <div v-if="collection.id" class="w-full relative">
        <VanTabs
          :active="currentTab"
          :offset-top="56"
          :swipe-threshold="6"
          class="h-full thread-tabs"
          sticky
          swipeable
          @update:active="clickTabChange"
        >
          <VanTab
            v-for="(item, idx) in collectionTypeList"
            :key="item"
            :title="`${t(`collection.${item}`)}${count(idx)}`"
          >
            <boxed-tab
              :selected-idx="list[idx].sortIdx"
              class="m-1"
              @update:selected-idx="onSorterChange"
            >
              <div
                v-for="(item, idx) in viewMode === 'edit'
                  ? SORTER_ENUM.slice(0, 1)
                  : SORTER_ENUM.slice(0, 3)"
                :key="idx"
              >
                {{ item.text }}
              </div>
            </boxed-tab>
            <scroll-loading-list
              ref="momentListRef"
              :on-scroll-load="reloadList"
              :scroller="scrollableEl"
              class="min-h-full"
            >
              <div>
                <div class="p-3">
                  <collection-thread-item
                    v-for="(item, nIdx) in list[idx].list"
                    :key="item.id"
                    :collectionItem="item"
                    :idx="nIdx"
                    :list="list[idx].list"
                    :moment="item.collectable as Moment"
                    :next-item="
                      nIdx === list[idx].list.length - 1
                        ? undefined
                        : list[idx].list[nIdx + 1]
                    "
                    :pre-item="
                      nIdx === 0 ? undefined : list[idx].list[nIdx - 1]
                    "
                    :showCoinVote="true"
                    :viewMode="viewMode"
                    enable-audio-play
                    @reaction-click="onActionClick(item)"
                  />
                </div>
              </div>
            </scroll-loading-list>
          </VanTab>
          <VanTab
            key="feedback"
            :title="
              t(`collection.feedback`, {
                count:
                  (collection.reply?.emojiVotezz?.length || 0) +
                    (replyCount?.replyCount || 0) >
                  99
                    ? '99+'
                    : (collection.reply?.emojiVotezz?.length || 0) +
                      (replyCount?.replyCount || 0),
              })
            "
          >
            <div class="p-4">
              <div class="flex flex-col gap-2 pb-5 border-b mb-2">
                <reaction-mate :reply="collection?.reply" />
                <div class="flex w-full justify-between items-end">
                  <div class="flex gap-2 flex-wrap">
                    <div class="flex gap-1">
                      <button class="btn btn-sm rounded" @click="showEmoji++">
                        <i class="iconify mingcute--thumb-up-line"></i>
                      </button>
                      <!-- @vue-ignore -->
                      <button
                        class="btn btn-sm rounded"
                        @click="()=>onReplyBtnClick({ ...collection.reply!, mate: collection.mate })"
                      >
                        {{ $t("Overview.comments") }}
                        <span v-if="replyCount?.replyCount > 0">
                          ({{ replyCount?.replyCount }})
                        </span>
                      </button>
                    </div>
                    <reaction-counter :reply="collection.reply" />
                  </div>
                </div>
              </div>
              <div>
                {{ replyCount?.replyCount || 0 }}
                {{ $t("Overview.comments") }}
              </div>
              <reply-list
                :entity-id="collection?.id"
                :root-id="collection?.replyId"
                class="pb-[60px]"
                entity-type="App\Models\Collection"
                @on-reply-click="onReplyBtnClick"
                @on-reaction-click="onReplyActionClick"
              />
            </div>
          </VanTab>
        </VanTabs>
      </div>

      <!-- <div v-if="canEdit" class="absolute bottom-4 right-4 flex gap-2"> -->
      <!-- <button class="btn btn-primary btn-sm" @click="clickResetOrder">
          {{ $t(`collection.resetOrder`) }}
        </button> -->
      <!-- </div> -->
    </div>

    <!-- @vue-ignore -->
    <moment-actions
      v-model:show="showActions"
      :moment="toOperateMoment"
      :reply="toOperateReply"
      :showEmoji="showEmoji"
    />
    <reply-input
      v-if="currentTab === 4"
      ref="replyInputRef"
      :entity-id="collection?.id"
      :reply-target="replyTarget"
      class="absolute bottom-0 max-h-[60px] left-0 right-0"
      :entity-type="ReplyEntityType.Collection"
      :entity="collection"
    />

    <ModalSelectEntity
      v-model:show="showAddModal"
      :collection-id="collection.id!"
      :exclude-moment-ids="list[1].list.map((v) => v.collectableId)"
      :exclude-storybook-ids="list[2].list.map((v) => v.collectableId)"
      :exclude-game-ids="list[3].list.map((v) => v.collectableId)"
      @selected="onSelectEntity"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  ApiDeleteCollection,
  ApiGetCollection,
  ApiPostCollectionItem,
  ApiPostCollectionItemCreateMany,
} from "@/apis/collection";
import { showConfirmDialog, showLoadingToast } from "vant";
import { ref, computed, UnwrapRef, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { ApiGetCollectionItemPage } from "@/apis/collection";
import { useReply } from "@/stores/reply";
import { ScrollLoadingListInstance } from "@/components/mobile/ScrollLoadingList.vue";
import { nextTick } from "vue";
import { onActivated } from "vue";
import { useMate } from "@/stores/mate";
import { sessionStorageGet, sessionStorageSet } from "@/tools/sessionStorage";
import { ReplyInputInstance } from "@/components/mobile/reply/ReplyInput.vue";
import { PageRequest } from "@/types/api-types";
import { Collection, CollectionItem, CollectionType } from "@/types/collection";
import {
  Mate,
  Moment,
  Reply,
  SelectEntityType,
  StoryBook,
} from "@/types/entity";
import { StorageGet, StorageRemove } from "@/tools/localStorage";
import { ReplyEntityType } from "@/enums";
import { ToastWrapperInstance } from "vant/es";

const scrollableEl = ref<HTMLElement | null>(null);
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const replyStore = useReply();
const collection = ref<Collection>({} as Collection);
const showAddModal = ref(false);
const momentListRef = ref<ScrollLoadingListInstance[] | null>(null);

const mateStore = useMate();
const canEdit = computed(() =>
  collection.value.participantzz?.some(
    (v) => v.uuid === mateStore.userMate?.uuid
  )
);

const bannerStyle = computed(() => {
  if (collection.value.coverMedia?.url) {
    return {
      filter: "blur(5px)",
      background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${collection.value.coverMedia?.url})`,
      backgroundSize: "cover",
    };
  } else {
    return {
      filter: "blur(3px)",
      backgroundImage:
        "linear-gradient(45deg, rgb(81 7 115) 0%, rgb(196, 58, 48) 100%)",
      backgroundSize: "cover",
    };
  }
});
const count = (idx: number) => {
  if (idx === 0) return "";
  if (idx === 1) return `(${collection.value.momentCount})`;
  if (idx === 2) return `(${collection.value.storyBookCount})`;
  if (idx === 3) return `(${collection.value.galGameCount})`;
};

const clickMate = (mateUuid: string) => {
  router.push({ name: "mateHome", params: { uuid: mateUuid } });
};
const clickDelete = async (uuid: string, name: string) => {
  let loading: ToastWrapperInstance | undefined;
  try {
    await showConfirmDialog({
      title: t("Message.delete"),
      message: t("Message.confirmDeletion", { name }),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });

    loading = showLoadingToast({ message: t("Message.loading") });
    await ApiDeleteCollection(uuid);
    sessionStorageSet("reloadMateHome", 1);
    router.back();
    loading.close();
  } catch (e) {
    if (loading) loading.close();
  }
};

const onSelectEntity = (
  data: number[] | StoryBook | Mate,
  type: SelectEntityType
) => {
  if (type === "moment") {
    onSelectMoment(data as number[]);
  } else if (type === "storyBook") {
    onSelectStorybook(data as StoryBook);
  }
  showAddModal.value = false;
};

const onSelectMoment = async (idzz: number[]) => {
  const loading = showLoadingToast({ message: t("Message.saving") });
  try {
    await ApiPostCollectionItemCreateMany({
      mateId: mateStore.currentMate!.id!,
      collectionId: collection.value.id!,
      collectableType: "moment",
      collectableIdzz: idzz,
    });
    reloadPage(true);
    loading.close();
  } catch (e) {
    loading.close();
  }
};

const onSelectStorybook = async (data: StoryBook) => {
  const loading = showLoadingToast({ message: t("Message.saving") });
  try {
    await ApiPostCollectionItem({
      mateId: mateStore.currentMate!.id!,
      collectionId: collection.value.id!,
      collectableType: "storyBook",
      collectableId: data.id!,
    });
    reloadPage(true);
    loading.close();
  } catch (e) {
    loading.close();
  }
};

// const showSelectGame = ref(false);

// const onSelectGame = async (data: number) => {
//   const loading = showLoadingToast({ message: t("Message.saving") });
//   try {
//     await ApiPostCollectionItem({
//       mateId: collection.value.mateId,
//       collectionId: collection.value.id!,
//       collectableType: "galGame",
//       collectableId: data,
//     });
//     reloadPage(true);
//     loading.close();
//   } catch (e) {
//     loading.close();
//   }
// };

const currentTab = ref(0);
const initState = () => ({
  list: [],
  scrollTop: 0,
  sortIdx: 0 as 0 | 1 | 2 | 3 | 4,
});
const list = ref<
  { list: CollectionItem[]; scrollTop: number; sortIdx: 0 | 1 | 2 | 3 | 4 }[]
>([
  initState(), // 全部
  initState(), // 动态
  initState(), // 故事
  initState(), // 游戏
  initState(), // 反馈
]);
const collectionTypeList = computed(() => {
  if (viewMode.value === "edit") return ["all"];
  return ["all", "moment", "storyBook"];
});

const PER_PAGE = 999;
const reloadList = async (tabIdx?: number, isReset?: boolean) => {
  tabIdx = tabIdx ?? currentTab.value;
  let { list: _list, sortIdx } = list.value[tabIdx];
  let perPage = [0, 1].includes(tabIdx) ? 6 : PER_PAGE;
  if (perPage === 999 && _list.length !== 0 && !isReset) return false;
  const page = _list.length / perPage + 1;
  if (!Number.isInteger(page)) return false;

  let collectableType: CollectionType | undefined = undefined;

  if (tabIdx > 0)
    collectableType = collectionTypeList.value[tabIdx] as CollectionType;

  let order: "asc" | "desc" = [1, 3].includes(sortIdx) ? "desc" : "asc";
  let field = [1, 2].includes(sortIdx) ? "dtPublish" : "id";
  let params: PageRequest<{
    collectionId?: number;
    collectableType?: CollectionType;
  }> = {
    filter: {
      collectableType,
      collectionId: collection.value.id,
    },
    pagination: {
      page,
      perPage,
    },
  };
  if (sortIdx !== 0) params.sort = { field, order };
  const res = await ApiGetCollectionItemPage(params);
  const { data } = res.page;
  const hasMap: Record<string, boolean> = {};
  _list.forEach((v) => (hasMap[v.collectable!.uuid!] = true));

  data.forEach((v) => {
    if (!hasMap[v.collectable!.uuid!]) _list.push(v);
  });
  // _list.push(...data);
  replyStore.updateMap(data.map((v) => v.collectable!.reply!) as Reply[]);
  return data.length === perPage;
};

// scroll
const clickTabChange = (tab: number) => {
  currentTab.value = tab;
  nextTick(() => {
    if (list.value[tab].list.length === 0 && tab !== 4) {
      reloadList(tab);
    } else {
      scrollableEl.value!.scrollTop = list.value[tab].scrollTop;
    }
  });
};

const saveScrollState = () => {
  if (!scrollableEl.value) return;
  list.value[currentTab.value].scrollTop = scrollableEl.value.scrollTop;
};

let isInit = ref(false);

onActivated(async () => {
  init();
});

onMounted(() => {
  init();
});

const init = () => {
  scrollableEl.value?.scrollTo(0, list.value[currentTab.value].scrollTop || 0);
  let isChange = collection.value.uuid !== route.params.uuid;
  if (isChange || StorageGet("collectionUpdated")) {
    collection.value = {} as Collection;
    reloadPage(isChange);
    StorageRemove("collectionUpdated");
  }
};

const reloadPage = async (reloadList = false) => {
  const { item } = await ApiGetCollection(String(route.params.uuid));
  item.participantzz.sort((a: Mate) => (a.id === item.mateId ? -1 : 1));
  collection.value = item;
  viewMode.value = "view";

  replyStore.getOrFetchReplyTreeList(item.id, "App\\Models\\Collection");

  if (!isInit.value || reloadList) resetList();
  const deleteMomentUUid = sessionStorageGet("momentDeleted");
  if (deleteMomentUUid) {
    const idx = list.value[1].list.findIndex(
      (v) => v.collectable?.uuid === deleteMomentUUid
    );
    if (idx !== -1) {
      list.value[1].list.splice(idx, 1);
    }
    const idx2 = list.value[0].list.findIndex(
      (v) => v.collectable?.uuid === deleteMomentUUid
    );
    if (idx2 !== -1) {
      list.value[0].list.splice(idx2, 1);
    }
  }

  const { reply } = collection.value;
  if (reply) {
    replyTarget.value = {
      ...reply,
    };
    replyStore.updateMap([reply]);
    collection.value.reply = replyStore.getReply(reply.id!)!;

    //@ts-ignore
    toOperateMoment.value = { reply };
  }
  isInit.value = true;
};

const replyCount = computed(
  () => replyStore.countOwnerMap[collection.value?.id]
);
// sort
const selectedSorterIdx = ref(0);
const SORTER_ENUM: { text: string; value: string }[] = [
  { text: t(`collection.authorSort`), value: "author" },
  { text: t("collection.publishDesc"), value: "publish-desc" },
  { text: t("collection.publishAsc"), value: "publish-asc" },
  { text: t("collection.collectionDesc"), value: "collection-desc" },
  { text: t("collection.collectionAsc"), value: "collection-asc" },
];
const onSorterChange = (idx: number) => {
  selectedSorterIdx.value = idx;
  const currentTabs = list.value[currentTab.value];
  currentTabs.sortIdx = idx as 0 | 1 | 2 | 3 | 4;
  if (idx === 0 || currentTab.value === 0 || currentTab.value === 1) {
    currentTabs.list = [];
    momentListRef.value![currentTab.value].resetScrollLoadingState();
  } else {
    currentTabs.list = currentTabs.list.sort((a, b) => {
      if (SORTER_ENUM[idx].value.includes("desc")) {
        return b.collectable!.id! - a.collectable!.id!;
      } else {
        return a.collectable!.id! - b.collectable!.id!;
      }
    });
  }
};

// action
const showActions = ref(false);
const activeCollectionItem = ref<CollectionItem | null>(null);
const onActionClick = (moment: UnwrapRef<CollectionItem>) => {
  activeCollectionItem.value = moment;
  showActions.value = true;
};

const resetList = () =>
  new Promise((v) => {
    nextTick(() => {
      list.value = [
        initState(),
        initState(),
        initState(),
        initState(),
        initState(),
      ];
      momentListRef.value?.forEach((ref) => ref?.resetScrollLoadingState());
      Promise.all([1, 2, 3].map((v) => reloadList(v, true))).then(v);
    });
  });

// const onMomentDelete = () => {
//   showActions.value = false;
//   reloadPage(true);
// };

const replyTarget = ref<Reply | null>(null); // 底部输入框的回复目标
const replyInputRef = ref<ReplyInputInstance | null>(null);
const showEmoji = ref(0);
const toOperateMoment = ref<Moment | null>(null);
const toOperateReply = ref<Reply | null>(null);

const onReplyBtnClick = (replay: Reply) => {
  replyTarget.value = replay;
  replyInputRef.value?.focus();
};
const onReplyActionClick = (reply: Reply) => {
  toOperateReply.value = reply;
  showActions.value = true;
};

// 编辑模式
const viewMode = ref("view");
const clickMode = async () => {
  if (viewMode.value === "view") {
    if (currentTab.value !== 0) {
      currentTab.value = 0;
      reloadList(0, true);
    }
    if (mateStore.currentMate?.id !== mateStore.userMate?.id) {
      const loading = showLoadingToast(t(`Message.loading`));
      await mateStore.changeCurrentMate(mateStore.userMate!.id!);
      loading.close();
    }
    viewMode.value = "edit";
  } else {
    viewMode.value = "view";
  }
};

// 重置
// const clickResetOrder = async () => {
//   const loading = showLoadingToast({ message: t("Message.resetting") });
//   await ApiPostCollectionItemSort(collection.value.id!);
//   loading.close();
//   reloadPage(true);
// };
</script>
